import clsx from 'clsx'
import { useControlField, useField } from 'remix-validated-form'

import { FieldContainer } from '~/components'

type SelectFieldProps = {
  className?: string
  label?: string
  name: string
  required?: boolean
  disabled?: boolean
  options: string[] | { [key: string]: string }
  defaultNone?: boolean
  onBlur?: (e: React.FocusEvent<HTMLSelectElement, Element>) => void
  onChange?: (value: string) => void
}

export default function SelectField(props: SelectFieldProps) {
  const {
    name,
    disabled,
    options,
    defaultNone = true,
    onBlur,
    onChange,
  } = props
  const { error, getInputProps, defaultValue } = useField(name)
  const [value, setValue] = useControlField<string>(name)

  return (
    <FieldContainer {...props} id={name}>
      <select
        {...getInputProps({
          id: name,
          value: value || '',
          onBlur,
          onChange: (e) => {
            setValue(e.target.value)
            onChange?.(e.target.value)
          },
        })}
        className={clsx(
          'flex h-10 w-full rounded-md border border-input bg-background py-2 pl-3 pr-5 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          defaultValue &&
            value != defaultValue &&
            'ring-2 ring-yellow-300 ring-offset-2',
          !defaultValue && value && 'ring-2 ring-green-400 ring-offset-2',
          disabled && 'pointer-events-none bg-gray-50'
        )}>
        {defaultNone && <option value="">None</option>}
        {Array.isArray(options)
          ? options.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))
          : Object.keys(options).map((key, index) => (
              <option key={index} value={key}>
                {options[key]}
              </option>
            ))}
      </select>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </FieldContainer>
  )
}
